import React from 'react';
import classNames from 'classnames';

import './footer-bottom.scss';

interface FooterBottomProps {
  children?: any;
  hasButton?: boolean;
  twoButtons?: boolean;
}

const FooterBottom: React.SFC<FooterBottomProps> = props => (
  <div
    className={classNames('c-footer-bottom', {
      'c-footer-bottom--with-button c-footer-bottom--two-buttons':
        props.twoButtons,
      'c-footer-bottom--with-button': props.hasButton
    })}
  >
    {props.children}
  </div>
);

export default FooterBottom;



// WEBPACK FOOTER //
// ./src/components/layout/footer-bottom.tsx